import api from '../api';

import { ParamsDataOrderDetailScheduling } from 'utils/typeServices';

export const GetOrderDetailScheduling = async ({ token, cdPedido }: { token: string, cdPedido: string }) => {
    try {
        const { data } = await api.get<{ Data: ParamsDataOrderDetailScheduling }>(`v1/Agendamento/GetOrderDetailScheduling?cdPedido=${cdPedido}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
        
        return { data: data.Data };
    } catch (error: any) {
        if ((error?.response.data?.ErrorCode === "limite_agendamento_excedido")) {
            return { data: false };
        }
        return { data: null};
    }
}
